import { optionSubcategory_category } from './categoriesSubCategory.locstring.json';
import CategoriesOption from 'owa-categories-option/lib/CategoriesOption';
import selectCategoriesOptionsAction from 'owa-options-actions/lib/selectCategoriesOptions';
import { OptionSubCategory } from 'owa-options-core';
import { loadFavorites } from 'owa-favorites';

let categoriesSubCategory: OptionSubCategory = {
    key: 'categories',
    titleStringKey: optionSubcategory_category,
    options: [CategoriesOption],
    onSelected: () => {
        selectCategoriesOptionsAction();
        loadFavorites();

        return Promise.resolve(true);
    },
};

export default categoriesSubCategory;
